import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { ApiService, AuthService, LoadingStateService, ReportService } from '@services/index';
import { authInterceptor } from './reports/core/services/auth.interceptor';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync('animations'),
    ApiService,
    AuthService,
    LoadingStateService,
    ReportService,
  ]
};
